<template>
	<div v-show="menu" class="page menu">
		<div class="top-menu">
			<img src="../assets/gta-logo-black.svg" alt="" class="logo" />
			<button class="close-menu" @click="toggleMenu()">
				<img src="../assets/icons/close-icon.svg" alt="" />
			</button>
		</div>
		<div class="menu-container">
			<div class="content">
				<div class="top">
					<span>GTA Supports</span>
					<div class="doted-line"></div>
				</div>
				<div class="content-entity">
					<div class="entities">
						<div v-for="(entity, i) in content.entities" :key="i" class="entity">
							<div
								class="colored-border"
								:style="{
									'background-color': entity.colors.primary,
								}"
							></div>
							<div class="entity-content">
								<div class="entity-top">
									<img :src="`./assets/entities_logos/colored/${entity.entity_logo.colored}`" alt="" class="logo" />
								</div>
								<div class="share-links black-2 fs-1 montserra-r">
									<a :href="entity.links.site" title="" target="_blank">Site Web</a>
									<a :href="entity.links.instagram" title="" target="_blank"> Instagram </a>
									<a :href="entity.links.linkedin" title="" target="_blank"> Linkedin </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a :href="content.legal_notice" class="legal-mention black-1 coco fs-1-1" title="" target="_blank">Mentions légales </a>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.menu {
		transition: all 0.6s ease;
		box-sizing: border-box;
		z-index: 50;
		background-color: #fff;
		position: absolute;

		top: 0;
		left: 0;
		padding: 2rem 4rem;
		display: flex;
		flex-direction: column;
		.top-menu {
			display: flex;
			justify-content: space-between;
			align-items: center;
			img.logo {
				height: 3.4rem;
			}
			button.close-menu {
				align-self: flex-end;
				img {
					will-change: transform;
					transition: transform 0.3s ease-in;
					width: 2.625rem;
				}
				&:hover {
					img {
						transform: scale(1.2);
					}
				}
			}
			margin-bottom: 5rem;
		}

		.menu-container {
			box-sizing: border-box;
			padding: 0 8rem;
			flex: 1;
			div.content {
				display: flex;
				flex-direction: column;
				height: 100%;
				.top {
					display: flex;
					flex-direction: row;
					align-items: center;
					margin-bottom: 3.5rem;
					span {
						font-family: "Cocogoose", sans-serif;
						color: rgba(44, 47, 51, 1);
						margin-right: 34px;
						white-space: nowrap;
						font-size: 20px;
					}
					.doted-line {
						width: 100%;
						height: 0px;
						border-bottom: 2px dashed #2c2f33;
					}
				}
				.content-entity {
					flex: 1;
					overflow-y: auto;
					position: relative;
					.entities {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						display: flex;
						flex-direction: row;
						flex-wrap: wrap;
						.entity {
							background-color: var(--white);
							box-shadow: var(--shadow-1);
							margin: 0 1.25rem 2rem 0;
							width: 300px;
							// height: 240px;
							box-sizing: border-box;
							overflow: hidden;
							border-radius: 11px;

							display: flex;
							flex-direction: column;
							.colored-border {
								width: 100%;
								height: 0.8rem;
							}
							.entity-content {
								display: flex;
								flex-direction: column;

								box-sizing: border-box;
								padding: 1rem;

								.entity-top {
									padding-bottom: 1rem;
									.logo {
										height: 2.5rem;
									}
									// dots
									border-bottom: 0.5px dashed var(--black-1);
								}
								.share-links {
									margin-top: 1.25rem;
									display: flex;
									flex-direction: column;
									a {
										text-decoration: none;
										margin-bottom: 0.75rem;

										&:last-child {
											margin-bottom: 2rem;
										}
										&:hover {
											text-decoration: underline;
										}
									}
								}
							}
						}
					}
				}
				a.legal-mention {
					margin-top: 1rem;
					margin-bottom: 2rem;
					text-decoration: none;
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}
</style>
<script>
	import { mapState, mapActions } from "vuex";
	export default {
		data() {
			return {
				active: false,
			};
		},
		computed: {
			...mapState(["menu", "content"]),
		},
		methods: {
			...mapActions(["toggleMenu"]),
		},
	};
</script>
